import React, { useState } from "react";
import Button from "../../Button";
import apiInstance from "../../apiInstance";

const PauseResumeWebsite = ({
    data = {},
    type,
    closePopup,
    updateWebsite,
    updateError,
}) => {
    const {website} = data;
    const websiteId = website._id;
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            if (type === "pause") {
                const res = await apiInstance.post(`/dashboard/website/pause/${websiteId}`);
                updateWebsite && updateWebsite(res.data.website, res.data.counts);
                closePopup();
                setLoading(false)
            } else if(type == "resume") {
                const res = await apiInstance.post(`/dashboard/website/resume/${websiteId}`);
                updateWebsite && updateWebsite(res.data.website, res.data.counts);
                closePopup();
                setLoading(false)
            }
        } catch (error) {
            console.error(`Error:`, error);
            updateError &&
                updateError(error.response?.data?.message || "Something went wrong, please try again later.");
            setLoading(false);
        }
    };

    return (
        <div className="mjwidev-pp">
            <h2>{type == "pause" ? "PAUSE" : "RESUME"} WEBSITE</h2>

            {type === "resume" && website?.pausedAt && (
                <p>                    
                    Paused on{" "}
                    <strong>{new Date(website.pausedAt).toLocaleDateString()}</strong>
                </p>
            )}

            <p>
                Are you sure you want to {type == "pause" ? "pause" : "resume"} the website?
            </p>

            {type === "resume" && website?.subscription?.currentPeriodEnd && (
                <p>                    
                    Once resumed, billing will restart and next charge will be on {" "}
                    <strong>{new Date(website?.subscription?.currentPeriodEnd).toLocaleDateString()}</strong>
                </p>
            )}

            <div className="mjwidev-bottom-row">
                <Button name="Continue" eventHandler={handleSubmit} />
                {loading && (
                    <i
                        className="fa-solid fa-spinner fa-spin"
                    ></i>
                )}
            </div>
        </div>
    );
};

export default PauseResumeWebsite;
